import React from "react";
import PropTypes from "prop-types";

import styles from "./Channel.module.scss";


const TextChannelItem = (props) => {

    function createMarkup() { return { __html: props.entry.message }; };

    let display = null;
    if (props.entry && props.entry.message && props.entry.message.length > 0) {
        display = <div className={styles.channelItemMessage} dangerouslySetInnerHTML={createMarkup()} />
    }
    return (<div className={styles.channelItemMessage}>{display}</div>);
}

TextChannelItem.propTypes = {
    entry: PropTypes.object
}

export default TextChannelItem;